import { Suspense } from 'react'
import { Spinner } from '@agion/ui'
import { lazyWithRetry } from '@/app/router/lazyWithRetry'
import { useUIVariant } from '@/shared/ui-variant'
import { MainLayout } from './MainLayout'

// The next shell is its own chunk; a member on the current interface never downloads it.
const NextShell = lazyWithRetry(() => import('@/next/shell/NextShell'))

function ShellHold() {
  return (
    <div className="flex h-screen items-center justify-center" data-testid="ui-variant-hold">
      <Spinner size="lg" />
    </div>
  )
}

/**
 * Picks the shell from the server resolution (agion/Agion#3210). The next
 * shell renders from the first paint, while the server answers and after any
 * failed answer; the current interface renders only once the server has
 * answered `legacy`, so it never mounts first on a fresh browser.
 */
export function VariantShell() {
  const { variant } = useUIVariant()
  if (variant === 'legacy') {
    return <MainLayout />
  }
  return (
    <Suspense fallback={<ShellHold />}>
      <NextShell />
    </Suspense>
  )
}
